import React from "react"
import "./style.scss"
import Scroll from "react-scroll"
import Carousel from "react-slick"
import navRight from "../../../images/scrollbottom.svg"
import navLeft from "../../../images/scrollbottom.svg"
import {
  makeStyles,
} from "@material-ui/core"
// import classNames from "classnames"

const useStyles = makeStyles((theme) => ({
  next: {
    position: "absolute",
    marginLeft: "48%",
    [theme.breakpoints.down('741')]: {
      marginLeft: '31%',
		},
  },
  prev: {
    // position: "absolute",
    marginLeft: "48%",
    transform: 'rotate(180deg)',
    marginTop: '-12%',
    [theme.breakpoints.down('741')]: {
			marginTop: '-29%',
      marginLeft: '31%',
		},
  },
  carousel: {
    '& .slick-list': {
      height: '410px !important',
    },
  },
}))

let Link = Scroll.Link
let Element = Scroll.Element
const Tags = ({ tags }) => {
  const classes = useStyles()

  const NextArrow = props => {
    const { onClick, style, currentSlide } = props
    // style.display = onClick === null ? "none" : "block"
    return (
      // currentSlide !== 2 && (
      <img
        src={navRight}
        className={classes.next}
        onClick={onClick}
        style={style}
        alt="next"
      />
      // )
    )
  }

  const PrevArrow = props => {
    const { onClick, currentSlide } = props
    return (
      // currentSlide !== 0 && (
        <img src={navLeft} className={classes.prev} onClick={onClick} alt="prev"/>
      // )
    )
  }

  const sliderSettings = {
    slidesToShow: 4,
    speed: 500,
    infinite: false,
    slidesToScroll: 1,
    rows: 1,
    dots: false,
    vertical: true,
    verticalSwiping: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1050,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 1,
        },
      },
    ],
  }

  return (
    <div className="tag-area">
      {/* <div className="arrow-up">
        <Link
          to="first"
          spy={true}
          smooth={true}
          duration={250}
          containerId="tags"
        >
          <img alt="scrolltop" />
        </Link>
      </div>

      <div className="arrow-down">
        <Link
          to="last"
          spy={true}
          smooth={true}
          duration={250}
          containerId="tags"
        >
          <img alt="scrollbottom" />
        </Link>
      </div> */}

      <Element className="wersel_tags" id="tags">
       {/* <Carousel {...sliderSettings} className={classes.carousel}> */}
        {tags &&
          tags.map((item, indx) => {
            const { tag, tagline, color } = item
            if (indx === 0) {
              return (

                <Element key={indx} name="first" style={{ paddingTop: "2rem" }}>
                  <TagItem tag={tag} tagline={tagline} color={color} />
                </Element>
              )
            }
            if (indx === tags.length - 1) {
              return (
                <Element key={indx} name="last">
                  <TagItem
                    className="no-border"
                    tag={tag}
                    tagline={tagline}
                    color={color}
                  />
                </Element>
              )
            }
            return (
              <TagItem key={indx} tag={tag} tagline={tagline} color={color} />
            )
          })}
          {/* </Carousel> */}
      </Element>
    </div>
  )
}
const TagItem = ({ className, color, tag, tagline }) => {
  return (
    <div className={`tag-item ${className ? className : ""}`}>
      <div className="circle">
        <div style={{ backgroundColor: color }}></div>
      </div>
      <div className="tag-info">
        <h4 className="title">{tag}</h4>
        <p className="tag-line">{tagline}</p>
      </div>
    </div>
  )
}
export default Tags
